import { ThemeProvider, createTheme } from "@mui/material";
import { Header } from "./components/Header";
import { TabbedPage } from "./pages/TabbedPage";
import { QueryClient, QueryClientProvider } from "react-query";
import { useState } from "react";
import { SplashScreen } from "./pages/SplashScreen";

// Or Create your Own theme:
const theme = createTheme({
  palette: {
    secondary: {
      main: '#ABABAB'
    },
  }
});

const queryClient = new QueryClient()

function App() {
  // testing config
  const [location_id, setLocation_id] = useState<number>(localStorage.getItem("location_id") === null ? -1 : parseInt(String(localStorage.getItem("location_id"))));
  const [location_name, setLocation_name] = useState<string>(localStorage.getItem("location_name") === null ? "Login" : String(localStorage.getItem("location_name")));

  // deployment config
  // const [location_id, setLocation_id] = useState<number>(33);
  // const [location_name, setLocation_name] = useState<string>("Pharmacy");

  return (
    <QueryClientProvider client={queryClient}>
    <ThemeProvider theme={theme}>
      <Header handleUpdateLocation={(name, id) => {
        setLocation_name(name);
        setLocation_id(id);

        // store user in storage
        localStorage.setItem("location_name", name)
        localStorage.setItem("location_id", String(id))
      }}
      locName={location_name} />
      {
        ((location_name !== "Login")  &&
        <>
        <TabbedPage location_id={location_id} location_name={location_name} />
        {/* <Overview currentLocationID={1}/> */}
        {/* <CreateLocation /> */}
        {/* <CreateTask handleClose={() => {}}/> */}
        {/* <StartTask handleClose={() => {}} /> */}
        {/* <LocationOverview /> */}
        </>) || <SplashScreen />
      }
    </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
